// extracted by mini-css-extract-plugin
export default {"root":"il1dnj_7fn","root_small":"AaiEXP77cW","root_xSmall":"hrFnOx02Hz"};